<script setup lang="ts">
import type { NovaCalendarControlButtonProps } from './NovaCalendarControlButton.types'

withDefaults(defineProps<NovaCalendarControlButtonProps>(), {
  compact: false,
  on: false,
  disabled: false,
})
</script>

<template>
  <button
    type="button"
    :class="['calendar-control-button', { compact, on }]"
    :disabled="disabled"
  >
    <span class="label">{{ label }}</span>
  </button>
</template>

<style lang="scss" scoped>
.calendar-control-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  background-color: transparent;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;

  @include mobile {
    height: 24px;
    width: 60px;
  }

  &:hover {
    background-color: $color-bg-custom-11;
  }

  &.on {
    background-color: $color-bg-custom-11;
  }

  &.compact {
    width: 72px;
    height: 36px;

    > .label {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
    }
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  > .label {
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.59px;
    color: #6b7897;
    font-weight: 500;

    @include mobile {
      font-size: 14.69px;
      line-height: 17.63px;
      letter-spacing: 0.36px;
    }
  }
}
</style>
